import type { ButtonHTMLAttributes, Ref } from "react";
import "./button.css";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "primary" | "secondary" | "ghost";
  /** `sm`: 28 px e scritta piccola (un «Riprova» in una colonna stretta). Su touch sempre 44 px. */
  size?: "md" | "sm";
  /** Arriva al `<button>` (in React 19 `ref` è una prop), per riportarvi il focus. */
  ref?: Ref<HTMLButtonElement>;
};

// `className` viene unita alla classe base, non sostituita: un chiamante può
// aggiungere stili senza perdere `g-button` e la variante.
export function Button({ variant = "secondary", size = "md", type = "button", className, ...rest }: Props) {
  const classes = className ? `g-button ${className}` : "g-button";
  return <button type={type} data-variant={variant} data-size={size === "sm" ? "sm" : undefined} className={classes} {...rest} />;
}
